import { NgModule } from '@angular/core';

import { PartLocalManagerRoutingModule } from './part-local-manager.route';

@NgModule({
    declarations: [],
    imports:
        [
            PartLocalManagerRoutingModule
        ],
    providers: [],
    bootstrap: []
})
export class PartLocalManagerModule { }
